/**
 * @file useKeywordSearch.tsx
 *
 * @fileoverview Performs a keyword search against the backend using the search api autocomplete
 * endpoint.
 */
import { useState, useEffect, useContext } from 'react';
import { AppContext } from '~/jobiqo/context/app';
import { AppContextInterface } from '~/jobiqo/models/app';
import { getFrontend } from '~/jobiqo/utils/getFrontend';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
const SEARCH_API_AUTOCOMPLETE_URL = (process as any).env
  .searchAPIAutocompleteEndpoint;

/**
 * Do the keyword search in a side effect hook.
 */
export const useKeywordSearch = (searchTerm: string, endpoint: string) => {
  const [cities, setCities] = useState([]);
  const appContext: AppContextInterface = useContext(AppContext);
  const frontendConfig = useFrontendConfig();

  // @ts-ignore
  useEffect(() => {
    if (searchTerm.trim() !== '') {
      let isFresh = true;
      fetchKeywords(
        `${searchTerm}&l=${appContext.locale}&f=${getFrontend(frontendConfig)}`,
        endpoint,
      ).then((citiesResults) => {
        if (isFresh) {
          setCities(citiesResults);
        }
      });
      return () => (isFresh = false);
    }
  }, [searchTerm]);

  return cities;
};

const cache = {};
/**
 * Peforms the fetch query to the search api endpoint.
 */
const fetchKeywords = (value: string, endpoint: string) => {
  if (cache[value]) {
    return Promise.resolve(cache[value]);
  }

  if (!SEARCH_API_AUTOCOMPLETE_URL) {
    return Promise.resolve([]);
  }

  return fetch(`${SEARCH_API_AUTOCOMPLETE_URL}/${endpoint}?q=${value}`)
    .then((res) => res.json())
    .then((result) => {
      cache[value] = result;
      return result;
    });
};

export default useKeywordSearch;
